<template>
  <section class="page orderDetail">
    <div class="step-bar">
      <div class="step-wrap">
        <div class="icon-row">
          <div class="icon-box">
            <el-image
              class="icon-img"
              :src="require('@/assets/icon/icon-order-created.png')"
            ></el-image>
          </div>
          <div class="line-box active"></div>
          <div class="icon-box">
            <el-image
              v-if="detail.status === '0' || detail.status === '2'"
              class="icon-img"
              :src="require('@/assets/icon/icon-order-nopay.png')"
            ></el-image>
            <el-image
              v-else
              class="icon-img"
              :src="require('@/assets/icon/icon-order-haspay.png')"
            ></el-image>
          </div>
          <div
            class="line-box"
            :class="[
              detail.status === '1' || detail.status === '3' ? 'active' : '',
            ]"
          ></div>
          <div class="icon-box">
            <el-image
              v-if="detail.status !== '3'"
              class="icon-img"
              :src="require('@/assets/icon/icon-order-noappraise.png')"
            ></el-image>
            <el-image
              v-else
              class="icon-img"
              :src="require('@/assets/icon/icon-order-hasappraise.png')"
            ></el-image>
          </div>
        </div>
        <div class="info-row">
          <div class="info-box">
            <div class="title">下单</div>
            <div class="time">{{ detail.createTime || "-" }}</div>
          </div>
          <div class="info-box">
            <div class="title">付款</div>
            <div class="time">{{ detail.payTime || "-" }}</div>
          </div>
          <div class="info-box">
            <div class="title">评价</div>
            <div class="time">{{ detail.evaluateTime | datetimeText }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bar-block">
      <div class="order-bar">
        <div>
          订单号：{{ detail.orderNumber }}
          <span class="order-time">{{ detail.createTime }}</span>
        </div>
        <div class="right-action" :class="[statusClass]">
          {{ detail.status | statusText }}
        </div>
      </div>
    </div>
    <cart-table
      :goodsList="detail.ocOrderChildList || []"
      type="preOrder"
      :status="detail.status"
      :totalPrice="detail.payment || 0"
      :orderNumber="orderNumber"
      v-on:handlePay="handlePay"
      v-on:handleCancel="cancelOrder"
    >
    </cart-table>
    <!-- <div class="ou-card-bottom-gap"></div> -->
    <el-dialog
      key="__detail__"
      title="付款"
      :visible.sync="modalShow"
      width="500px"
      append-to-body
      :destroy-on-close="true"
      class="ou-modal pay-modal"
      @close="closed"
    >
      <div class="pay-modal-wrap">
        <div class="info-row">
          支付金额：<span class="price-span">{{
            (detail.payment || 0) | paymentText
          }}</span>
        </div>
        <div class="info-row">支付方式：</div>
        <div class="pay-way-wrap">
          <div
            class="pay-box"
            @click="selectWay('wx')"
            :class="[selectedWay === 'wx' ? 'active' : '']"
          >
            <div class="box-wrap">
              <el-image
                :src="require('@/assets/icon/wxpay.png')"
                fit="contain"
              ></el-image>
            </div>
            <el-image
              v-show="selectedWay === 'wx'"
              class="select-flag"
              :src="require('@/assets/icon/btn-pay-corner.png')"
              fit="contain"
            ></el-image>
          </div>
          <div
            class="pay-box"
            @click="selectWay('ali')"
            :class="[selectedWay === 'ali' ? 'active' : '']"
          >
            <div class="box-wrap">
              <el-image
                :src="require('@/assets/icon/alipay.png')"
                fit="contain"
              ></el-image>
            </div>
            <el-image
              v-show="selectedWay === 'ali'"
              class="select-flag"
              :src="require('@/assets/icon/btn-pay-corner.png')"
              fit="contain"
            ></el-image>
          </div>
        </div>
        <div v-show="selectedWay !== ''">
          <div class="info-row">扫码支付：</div>
          <div class="qrcode-box">
            <div id="qrcode2-detail" v-show="selectedWay === 'wx'"></div>
            <div id="qrcode-detail" v-show="selectedWay === 'ali'"></div>
            <div class="qrcode-tips">
              {{
                selectedWay === "wx"
                  ? "打开手机微信扫码支付"
                  : "打开手机支付宝扫码支付"
              }}
            </div>
            <div
              v-show="selectedWay === 'wx'"
              @click="refresh"
              class="qrcode-tips"
            >
              刷新
            </div>
            <div
              v-show="selectedWay === 'ali'"
              @click="refresh2"
              class="qrcode-tips"
            >
              刷新
            </div>
          </div>
        </div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mockPay">一键支付</el-button>
      </div> -->
    </el-dialog>
  </section>
</template>

<script>
import { checkIsBuy } from "@/api/bookstore/bookstore";
import QRCode from "qrcodejs2";
import { aliCode, wxCode, aliOrderQuery, wxOrderQuery } from "@/api/cart/cart";
import { mapGetters, mapActions } from "vuex";
import {
  apiGetUserOrderList,
  apiCancelOrder,
  apiAfterPay,
} from "@/api/user/order";
import CartTable from "./components/CartTable";
export default {
  name: "orderDetail",
  components: { CartTable },
  data() {
    return {
      codeUrl: null,
      codeUrl2: null,
      timer1: null,
      timer2: null,
      modalShow: false,
      selectedWay: "wx",
      detail: {},
      orderNumber: "",
      relevanceId: "",
      relevanceId_type: "",
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["getCheckGoods", "getTotalPrice", "userId"]),
    statusClass() {
      let className = "";
      switch (this.detail.status) {
        case "0":
          className = "waitPay";
          break;
        case "1":
          className = "waitEva";
          break;
        case "2":
          className = "cancel";
          break;
        case "3":
          className = "complete";
          break;
      }
      return className;
    },
  },
  filters: {
    paymentText(value) {
      let text = " - ";
      if (value || value === 0) {
        text = Number(value).toFixed(2);
      }
      return text;
    },
    statusText(value) {
      let text = " - ";
      switch (value) {
        case "0":
          text = "待付款";
          break;
        case "1":
          text = "待评价";
          break;
        case "2":
          text = "已取消";
          break;
        case "3":
          text = "已完成";
          break;
      }
      return text;
    },
    datetimeText(value) {
      if (!value) {
        return "-";
      }
      let date = value.split("T")[0] || "";
      let rest = value.split("T")[1] || "";
      return date + " " + rest.substr(0, 8);
    },
  },
  activated() {
    console.log("路由传参", this.$route.query);
    let { orderNumber, relevanceId, relevanceId_type } = this.$route.query;
    this.orderNumber = orderNumber;
    this.relevanceId = relevanceId;
    this.relevanceId_type = relevanceId_type;
    this.getOrderDetail(orderNumber);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path === "/user/orderDetail/orderAppraise") {
        let { orderNumber } = vm.$route.query;
        vm.orderNumber = orderNumber;
        vm.getOrderDetail(orderNumber);
      }
    });
  },
  mounted() {},
  beforeDestroy() {
    this.timer1 && clearInterval(this.timer1);
    this.timer2 && clearInterval(this.timer2);
  },
  methods: {
    getOrderDetail(orderNumber) {
      // TODO：此处暂时用hack的方式, 通过传入订单号筛选订单列表的方式获取详情
      apiGetUserOrderList({
        userId: this.userId,
        pageNum: 1,
        pageSize: 2,
        keyword: orderNumber,
      }).then((res) => {
        let list = res.rows || [];
        if (list.length >= 2) {
          this.$message.error("获取详情失败，请稍后重试");
          retrun;
        }
        this.detail = list[0] || {};
      });
    },
    switchTab() {},

    handlePay(e) {
      console.log("dianji");
      //判断是否有权限
      checkIsBuy({
        relevanceId: this.relevanceId,
        type: this.relevanceId_type,
      }).then((res) => {
        if (res.data == "1") {
          this.modalShow = true;
          this.selectedWay === "wx" && this.getWxCode();
          this.selectedWay === "ali" && this.getAliCode();
          this.selectedWay === "wx" && this.wxOrderState();
          this.selectedWay === "ali" && this.aliOrderState();
        } else {
          this.$message("书架中已存在本商品，无法重复购买");
        }
      });
    },
    mockPay() {
      // TODO:
      apiAfterPay({ id: this.detail.id }).then(() => {
        this.modalShow = false;
        this.$message.success("订单支付成功");
        this.timer1 && clearInterval(this.timer1);
        this.timer2 && clearInterval(this.timer2);
        setTimeout(() => {
          let { orderNumber } = this.$route.query;
          this.getOrderDetail(orderNumber);
        }, 800);
      });
    },
    getWxCode() {
      // 获取微信二维码
      wxCode(this.orderNumber).then((res) => {
        let code = res.data ? res.data.qrCode : null;
        if (!code) {
          this.$message.error("获取支付二维码失败");
          const dom = document.getElementById("qrcode2-detail");
          if (dom) dom.innerHTML = "";
          return;
        }
        this.codeUrl2 = code;
        this.$nextTick(() => {
          this.createQrcode2();
        });
      });
    },
    getAliCode() {
      // 获取支付宝二维码
      aliCode(this.orderNumber).then((res) => {
        let code = res.data ? res.data.qrCode : null;
        if (!code) {
          this.$message.error("获取支付二维码失败");
          const dom = document.getElementById("qrcode-detail");
          if (dom) dom.innerHTML = "";
          return;
        }
        this.codeUrl = code;
        this.$nextTick(() => {
          this.createQrcode();
        });
      });
    },
    createQrcode() {
      // 若存在，先删除二维码
      const dom = document.getElementById("qrcode-detail");
      if (dom) dom.innerHTML = "";
      // 这里会自动去取模版中的id为qrcode的
      const qrcode = new QRCode("qrcode-detail", {
        width: 150, // 宽
        height: 150, // 高
        text: this.codeUrl, // 链接地址
      });
      return qrcode;
    },
    createQrcode2() {
      // 若存在，先删除二维码
      const dom = document.getElementById("qrcode2-detail");
      if (dom) dom.innerHTML = "";
      // 这里会自动去取模版中的id为qrcode的
      const qrcode = new QRCode("qrcode2-detail", {
        width: 150, // 宽
        height: 150, // 高
        text: this.codeUrl2, // 链接地址
      });
      return qrcode;
    },
    //刷新二维码
    refresh() {
      $(".qrcode").html(""); //把之前的置为空
      this.getWxCode();
    },
    //刷新二维码
    refresh2() {
      $(".qrcode").html(""); //把之前的置为空
      this.getAliCode();
    },
    // 轮询微信订单状态
    wxOrderState() {
      this.timer1 = setInterval(() => {
        wxOrderQuery(this.orderNumber, "web").then((res) => {
          if (res.code == 200) {
            clearInterval(this.timer1);
            this.modalShow = false;
            this.$message.success("订单支付成功");
            setTimeout(() => {
              let { orderNumber } = this.$route.query;
              this.getOrderDetail(orderNumber);
            }, 800);
          }
        });
      }, 3000);
    },
    // 轮询支付宝订单状态
    aliOrderState() {
      this.timer2 = setInterval(() => {
        aliOrderQuery(this.orderNumber).then((res) => {
          if (res.code == 200) {
            clearInterval(this.timer2);
            this.modalShow = false;
            this.$message.success("订单支付成功");
            setTimeout(() => {
              let { orderNumber } = this.$route.query;
              this.getOrderDetail(orderNumber);
            }, 800);
          }
        });
      }, 3000);
    },
    //当点击弹出框的关闭时
    closed() {
      this.timer1 && clearInterval(this.timer1);
      this.timer2 && clearInterval(this.timer2);
    },
    cancelOrder() {
      // TODO：api取消订单
      apiCancelOrder({ id: this.detail.id }).then((res) => {
        if (!!res.data) {
          this.$message.success("订单取消成功");
          let { orderNumber } = this.$route.query;
          this.getOrderDetail(orderNumber);
        }
      });
    },
    selectWay(value) {
      if (value === "wx") {
        // this.selectedWay = this.selectedWay !== 'wx' ? 'wx' : ''
        this.selectedWay = "wx";
        this.getWxCode();
        clearInterval(this.timer2);
        clearInterval(this.timer1);
        this.wxOrderState();
      } else if (value === "ali") {
        // this.selectedWay = this.selectedWay !== 'ali' ? 'ali' : ''
        this.selectedWay = "ali";
        this.getAliCode();
        clearInterval(this.timer1);
        clearInterval(this.timer2);
        this.aliOrderState();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page.orderDetail {
  background-color: #fffefd;
}
.step-bar {
  .step-wrap {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 24px 20px 20px;
    .icon-row {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon-box {
        padding: 20px;
        .icon-img {
          width: 44px;
          height: 44px;
        }
      }
      .line-box {
        width: 260px;
        height: 0px;
        border-bottom: 6px dotted #999999;
        &.active {
          border-color: #2e9adb;
        }
      }
    }
    .info-row {
      width: 100%;
      display: flex;
      justify-content: center;
      .info-box {
        width: 135px;
        text-align: center;
        .title {
          color: #333333;
          font-size: 14px;
        }
        .time {
          color: #999999;
          font-size: 13px;
          margin-top: 15px;
        }
        & + .info-box {
          margin-left: 208px;
        }
      }
    }
  }
}
.bar-block {
  padding: 0 20px;
  box-sizing: border-box;
}
.order-bar {
  width: 100%;
  height: 40px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  background-color: #f2f2f2;
  padding: 0 16px;
  color: #333333;
  font-size: 14px;
  .order-time {
    padding-left: 18px;
  }
  .right-action {
    width: 220px;
    text-align: center;
    // margin-right: 32px;
    &.waitPay {
      color: #ff5353;
    }
    &.waitEva {
      color: #f6a200;
    }
    &.complete {
      color: #2e9adb;
    }
    &.cancel {
      color: #999999;
    }
  }
}

.ou-modal.pay-modal ::v-deep {
  .el-dialog__body {
    padding-bottom: 0;
  }
}

.pay-modal-wrap {
  .info-row {
    display: flex;
    align-items: center;
    padding: 8px;
  }
}

.price-span {
  font-size: 18px;
  font-weight: 400;
  color: #ff5353;
  margin-left: 16px;
  &::before {
    content: "¥";
  }
}

.pay-way-wrap {
  padding: 28px 20px 34px;
  display: flex;
  justify-content: space-between;
  .pay-box {
    width: 180px;
    height: 56px;
    position: relative;
    box-sizing: border-box;
    border: 1px solid #f2f2f2;
    cursor: pointer;
    .box-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.active {
      border: 1px solid #2e9adb;
    }
    .select-flag {
      position: absolute;
      bottom: -1px;
      right: 0;
    }
  }
}

.qrcode-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 20px 48px;
  flex-direction: column;
  .qrcode-img {
    width: 150px;
    height: 150px;
  }
  .qrcode-tips {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin-top: 20px;
    cursor: pointer;
  }
  .qrcode-tips:last-of-type {
    cursor: pointer;
  }
}
.dialog-footer ::v-deep {
  text-align: center;
  .el-button {
    width: 200px;
    font-size: 16px;
    padding: 8px 20px;
    background-color: #2e9adb;
    border-radius: 6px;
  }
}
</style>
